module.exports = __webpack_public_path__ + "img/left-arrow.f9c231d9.svg";